export default {
    apiKey: "AIzaSyC9MuGhw9IB7Z49pW8CJelFi_iUex_EMZQ",
    authDomain: "staytion-website.firebaseapp.com",
    databaseURL: "https://staytion-website.firebaseio.com",
    projectId: "staytion-website",
    storageBucket: "staytion-website.appspot.com",
    messagingSenderId: "300822545848",
    appId: "1:300822545848:web:79fce2e7722bc54c1c3b4d",
    measurementId: "G-N2RQC9T70H"
};